import {
    format,
    addYear,
    addMonths,
    addDays,
    addHours,
    addMinutes,
    addSeconds,
    addMilliseconds,
    dateParse,
    timeSpan
} from './date'
import { saveQuery, parseQuery } from './common.js'
import opt from './opt.js'
export default {
    //date
    format,
    addYear,
    addMonths,
    addDays,
    addHours,
    addMinutes,
    addSeconds,
    addMilliseconds,
    dateParse,
    timeSpan,
    saveQuery,
    parseQuery,
    ...opt
}